/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export type SelectLocale = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: string;
  placeholder: string;
  create: string;
  // Optional so translation files aren't forced to define them (and so en_US
  // stays key-for-key aligned with the other locales — see locale-provider.test).
  // The component supplies English fallbacks in-component (composeAriaLiveMessage),
  // and any locale MAY override these to localize. Announced through a polite
  // aria-live region when the caretAffordance multi-select changes, so
  // screen-reader users get spoken confirmation even though the accessibility
  // cursor can't be moved onto the caret programmatically. `${value}` is
  // substituted with the affected option label; `${count}` with the number of
  // remaining selections.
  valueRemovedAnnouncement?: string;
  selectionClearedAnnouncement?: string;
  // Accessible name (and tooltip title) for the clear button. `clearAll` is used
  // for multi-select (clears every value), `clearValue` for single-select.
  // Optional with English fallbacks in-component, mirroring the keys above.
  clearAll?: string;
  clearValue?: string;
};
const locale = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: 'No results found',
  placeholder: 'Select...',
  create: 'Create',
  valueRemovedAnnouncement: '${value} removed. ${count} selected.',
  selectionClearedAnnouncement: 'Selection cleared.',
  clearAll: 'Clear all',
  clearValue: 'Clear value'
};
export default locale;